import { useState } from "react";
import { useScrollY } from "~/lib/animations";
import { cn } from "~/lib/cn";
import { Button } from "~/components/primitives/Button";
import { MenuIcon } from "~/components/primitives/Icons";
import { Wordmark } from "./Wordmark";
import { MobileNav } from "./MobileNav";

const navItems = [
  { label: "Product", href: "#product" },
  { label: "Why Jotty", href: "#why" },
  { label: "About Kugie", href: "#about" },
  { label: "FAQ", href: "#faq" },
];

const CONTACT_HREF = "https://kugie.app/contact";

export function Header() {
  const scrolled = useScrollY(8);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <header
        className={cn(
          "fixed top-0 left-0 right-0 z-50 transition-all duration-[var(--duration-standard)] ease-[var(--ease-prism)]",
          scrolled && "pt-3",
        )}
      >
        <div
          className={cn(
            "mx-auto flex w-full max-w-[1280px] items-center justify-between rounded-[var(--radius-hero)] border border-transparent px-6 py-4 transition-all duration-[var(--duration-standard)] ease-[var(--ease-prism)] sm:px-10",
            scrolled && "glass",
          )}
        >
          <a href="/" aria-label="Jotty home">
            <Wordmark />
          </a>

          <nav
            className="hidden items-center gap-7 md:flex"
            aria-label="Primary"
          >
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-sm text-[color:var(--ink-muted)] transition-colors duration-[var(--duration-micro)] hover:text-glacial-navy"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-2 md:flex">
            <Button
              href={CONTACT_HREF}
              variant="primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Request an invite
            </Button>
          </div>

          <button
            type="button"
            className="inline-flex h-10 w-10 items-center justify-center rounded-[var(--radius-btn)] text-glacial-navy md:hidden"
            aria-label="Open menu"
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen(true)}
          >
            <MenuIcon size={20} aria-hidden="true" />
          </button>
        </div>
      </header>

      <MobileNav
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        items={navItems}
        contactHref={CONTACT_HREF}
      />
    </>
  );
}
